/* WLB Finder option illustrations — pure SVG strings keyed by option key.
   Pulled from the original lib/illustrations.jsx React module.
   Each call: WlbFinderIllos.render('alltag', '#0d8e8c') -> SVG string. */
window.WlbFinderIllos = (function () {
  'use strict';
  // Each entry returns SVG markup as a string. {{C}} placeholder is replaced
  // by the requested color before injection.
  var I = {
    alltag: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linecap="round">'
      + '<circle cx="60" cy="14" r="6"/><line x1="60" y1="2" x2="60" y2="6"/><line x1="60" y1="22" x2="60" y2="26"/>'
      + '<line x1="48" y1="14" x2="52" y2="14"/><line x1="68" y1="14" x2="72" y2="14"/>'
      + '<rect x="14" y="28" width="34" height="22" rx="2"/>'
      + '<path d="M24 28 v-4 a2 2 0 0 1 2 -2 h10 a2 2 0 0 1 2 2 v4"/>'
      + '<line x1="14" y1="38" x2="48" y2="38" opacity="0.5"/></svg>',

    freizeit: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
      + '<circle cx="14" cy="14" r="5"/>'
      + '<path d="M2 50 Q 18 38, 30 44 T 60 36 T 78 28"/>'
      + '<path d="M40 14 l8 4 l-8 4 z" fill="{{C}}" opacity="0.3"/>'
      + '<path d="M40 14 l8 4 l-8 4 z"/></svg>',

    stadt: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linecap="square">'
      + '<rect x="8" y="22" width="14" height="32"/><rect x="26" y="14" width="16" height="40"/>'
      + '<rect x="46" y="28" width="12" height="26"/><rect x="62" y="18" width="12" height="36"/>'
      + '<line x1="11" y1="28" x2="11" y2="30"/><line x1="17" y1="28" x2="17" y2="30"/>'
      + '<line x1="11" y1="36" x2="11" y2="38"/><line x1="17" y1="36" x2="17" y2="38"/>'
      + '<line x1="29" y1="20" x2="29" y2="22"/><line x1="35" y1="20" x2="35" y2="22"/>'
      + '<line x1="29" y1="28" x2="29" y2="30"/><line x1="35" y1="28" x2="35" y2="30"/>'
      + '<line x1="29" y1="36" x2="29" y2="38"/><line x1="35" y1="36" x2="35" y2="38"/></svg>',

    feld: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<path d="M2 50 L20 28 L34 42 L50 20 L68 38 L78 30 L78 50 Z"/>'
      + '<path d="M2 50 L20 28 L34 42 L50 20 L68 38 L78 30" fill="none"/>'
      + '<circle cx="58" cy="14" r="4" fill="{{C}}" opacity="0.25"/><circle cx="58" cy="14" r="4"/></svg>',

    kinder: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<rect x="14" y="14" width="38" height="24" rx="2"/>'
      + '<line x1="14" y1="22" x2="52" y2="22" opacity="0.5"/>'
      + '<line x1="33" y1="14" x2="33" y2="38" opacity="0.5"/>'
      + '<circle cx="22" cy="48" r="6"/><circle cx="60" cy="48" r="6"/>'
      + '<line x1="52" y1="26" x2="64" y2="32"/></svg>',

    buero: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<rect x="10" y="20" width="36" height="22" rx="1.5"/>'
      + '<line x1="6" y1="44" x2="50" y2="44"/>'
      + '<circle cx="62" cy="20" r="10"/>'
      + '<line x1="62" y1="14" x2="62" y2="20"/><line x1="62" y1="20" x2="67" y2="22"/></svg>',

    regulaer: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<circle cx="18" cy="42" r="10"/><circle cx="62" cy="42" r="10"/>'
      + '<path d="M18 42 L34 22 L52 22 L62 42"/><path d="M34 22 L40 42 L62 42"/>'
      + '<line x1="40" y1="22" x2="40" y2="14"/><line x1="36" y1="14" x2="44" y2="14"/>'
      + '<line x1="56" y1="22" x2="60" y2="14"/></svg>',

    kompakt: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<circle cx="22" cy="42" r="7"/><circle cx="56" cy="42" r="7"/>'
      + '<path d="M22 42 L34 28 L48 28 L56 42"/><path d="M34 28 L38 42 L56 42"/>'
      + '<line x1="40" y1="28" x2="40" y2="22"/><line x1="36" y1="22" x2="44" y2="22"/>'
      + '<path d="M48 28 L52 24 L48 20" opacity="0.5"/></svg>',

    modern: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<circle cx="20" cy="42" r="9"/><circle cx="60" cy="42" r="9"/>'
      + '<path d="M20 42 L52 22 L60 42"/>'
      + '<path d="M30 42 L52 22" opacity="0.5"/>'
      + '<line x1="40" y1="14" x2="44" y2="14"/><line x1="42" y1="14" x2="42" y2="22"/></svg>',

    klassisch: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<circle cx="20" cy="44" r="9"/><circle cx="60" cy="44" r="9"/>'
      + '<path d="M20 44 Q 30 30, 44 28 L 52 22"/>'
      + '<path d="M40 44 L 52 22"/><path d="M52 22 L60 44"/>'
      + '<rect x="50" y="14" width="14" height="8" rx="1"/>'
      + '<line x1="36" y1="14" x2="40" y2="14"/></svg>',

    ja: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="2" stroke-linejoin="round" stroke-linecap="round">'
      + '<circle cx="40" cy="30" r="20" opacity="0.25" fill="{{C}}"/>'
      + '<path d="M30 30 L37 38 L52 22"/></svg>',

    nein: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="2" stroke-linejoin="round" stroke-linecap="round">'
      + '<circle cx="40" cy="30" r="20" opacity="0.15" fill="{{C}}"/>'
      + '<line x1="30" y1="20" x2="50" y2="40"/><line x1="50" y1="20" x2="30" y2="40"/></svg>',

    kurz: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<path d="M10 44 L18 36 L26 44 Z"/>'
      + '<rect x="14" y="44" width="8" height="6"/>'
      + '<path d="M28 46 L52 46" stroke-dasharray="2 3"/>'
      + '<rect x="54" y="36" width="16" height="14"/>'
      + '<line x1="58" y1="40" x2="58" y2="42"/><line x1="66" y1="40" x2="66" y2="42"/></svg>',

    lang: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<path d="M6 50 Q 22 38, 32 42 T 52 30 T 76 18"/>'
      + '<path d="M6 50 Q 22 38, 32 42 T 52 30 T 76 18" stroke-dasharray="3 3" opacity="0.4"/>'
      + '<circle cx="76" cy="18" r="3" fill="{{C}}" opacity="0.3"/>'
      + '<circle cx="76" cy="18" r="3"/></svg>',

    gemuetlich: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<path d="M22 22 Q 22 18, 26 18 M30 22 Q 30 18, 34 18 M38 22 Q 38 18, 42 18" opacity="0.5"/>'
      + '<path d="M18 26 L18 42 Q 18 48, 24 48 L40 48 Q 46 48, 46 42 L46 26 Z"/>'
      + '<path d="M46 30 Q 54 30, 54 36 Q 54 42, 46 42"/></svg>',

    sportlich: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<path d="M14 22 L24 22"/><path d="M10 30 L26 30"/><path d="M14 38 L24 38"/>'
      + '<circle cx="44" cy="42" r="8"/><circle cx="66" cy="42" r="8"/>'
      + '<path d="M44 42 L54 24 L66 42"/>'
      + '<path d="M50 22 Q 56 18, 62 22"/></svg>',

    asphalt: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<path d="M8 50 L30 14 L50 14 L72 50 Z" opacity="0.15" fill="{{C}}"/>'
      + '<path d="M8 50 L30 14"/><path d="M72 50 L50 14"/>'
      + '<path d="M40 16 L40 50" stroke-dasharray="3 4"/></svg>',

    gelaende: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<path d="M16 46 L10 36 L14 36 L8 26 L14 26 L12 18 L20 18 L18 26 L24 26 L18 36 L22 36 L16 46 Z"/>'
      + '<path d="M62 46 L56 36 L60 36 L54 26 L60 26 L58 18 L66 18 L64 26 L70 26 L64 36 L68 36 L62 46 Z"/>'
      + '<path d="M16 50 Q 30 44, 40 48 T 62 50" stroke-dasharray="2 3"/></svg>',

    hardtail: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<circle cx="20" cy="42" r="9"/><circle cx="60" cy="42" r="9"/>'
      + '<path d="M20 42 L40 22 L52 22 L60 42"/>'
      + '<path d="M40 22 L44 42 L60 42"/>'
      + '<line x1="46" y1="22" x2="46" y2="14"/><line x1="42" y1="14" x2="50" y2="14"/>'
      + '<path d="M20 42 L19 38 L21 36 L19 34 L21 32 L20 28"/></svg>',

    fully: '<svg viewBox="0 0 80 60" fill="none" stroke="{{C}}" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round">'
      + '<circle cx="20" cy="42" r="9"/><circle cx="60" cy="42" r="9"/>'
      + '<path d="M20 42 L40 22 L48 22 L60 42"/>'
      + '<path d="M40 22 L36 32 L44 38 L60 42"/>'
      + '<line x1="44" y1="22" x2="44" y2="14"/><line x1="40" y1="14" x2="48" y2="14"/>'
      + '<path d="M20 42 L19 38 L21 36 L19 34 L21 32 L20 28"/>'
      + '<path d="M40 32 L48 30" stroke-width="2.5"/>'
      + '<circle cx="40" cy="32" r="1.5" fill="{{C}}"/>'
      + '<circle cx="48" cy="30" r="1.5" fill="{{C}}"/></svg>'
  };

  return {
    has: function (key) { return Object.prototype.hasOwnProperty.call(I, key); },
    render: function (key, color) {
      if (!I[key]) return '';
      return I[key].split('{{C}}').join(color || 'currentColor');
    }
  };
})();
